import { useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, CaretDown } from "@phosphor-icons/react";
import { PageHeader } from "@/components/common";

const GUIDE = [
  { title: "Başlangıç", items: [
    ["Firma bilgileri", "Ayarlar → Firma Bilgileri'nden ad, adres, telefon, e-posta ve logo girin. Bu bilgiler fatura çıktısında ve e-postalarda kullanılır.", "/ayarlar"],
    ["Kullanıcı davet etme", "Ayarlar → Kullanıcılar → Yeni Kullanıcı. Davet e-postasındaki bağlantıyla kullanıcı kendi şifresini belirler. Rol: Yönetici (her şey) veya Kullanıcı (modül bazlı görüntüle/düzenle yetkisi).", "/ayarlar"],
    ["Belge numaraları", "Ayarlar → Numaralandırma'dan fatura/sipariş/tahsilat ön ekleri ve başlangıç numarasını ayarlayın.", "/ayarlar"],
  ] },
  { title: "Cari Hesaplar", items: [
    ["Cari ekleme ve Excel'den aktarma", "Cariler → Yeni Cari veya Excel'den Aktar (şablonu indirip doldurun). Tür: Müşteri, Tedarikçi veya Her ikisi.", "/cariler"],
    ["Ekstre ve bakiye", "Cari detayında tüm hareketler, açık faturalar ve bakiye görünür; ekstreyi yazdırabilir veya e-postayla gönderebilirsiniz.", "/cariler"],
    ["Mutabakat", "Cari detayı → Mutabakat ile tek cariye, Cariler → Toplu Mutabakat ile tüm açık bakiyeli carilere mektup gönderin. Cari e-postadaki bağlantıdan onaylar/itiraz eder; sonuçları Mutabakatlar sayfasında izleyin. 7 gün yanıt gelmezse otomatik hatırlatma gider.", "/mutabakatlar"],
  ] },
  { title: "Ürünler ve Stok", items: [
    ["Ürün tanımlama", "Ürünler → Yeni Ürün: birim, KDV, alış/satış fiyatı, kritik stok. Fotoğraf ekleyebilirsiniz.", "/urunler"],
    ["Stok hareketleri", "Satış faturası stoktan düşer, alış faturası stok ekler. Sayım farkları için stok düzeltme kullanın.", "/urunler"],
  ] },
  { title: "Fatura, Sipariş ve Tahsilat", items: [
    ["Fatura kesme", "Faturalar → Yeni Satış/Alış Faturası. Cari ve kalemleri seçin; KDV ve toplamlar otomatik hesaplanır.", "/faturalar/yeni"],
    ["Fiş fotoğrafından fatura (Pro)", "Faturalar → Fiş Fotoğrafından: fotoğrafı yükleyin, yapay zekâ tedarikçi ve kalemleri okur, kayıtlarınızla eşleştirir; taslağı kontrol edip kaydedin. Fotoğraf faturaya ek olarak saklanır.", "/faturalar"],
    ["Sipariş ve sevkiyat", "Siparişler → sevk bekleyenleri Sevkiyatlar'dan takip edin; faturaya dönüştürün.", "/siparisler"],
    ["Tahsilat / ödeme", "Kasa → Tahsilat veya Ödeme girin ya da fatura üzerinden online ödeme bağlantısı gönderin (Stripe).", "/kasa"],
    ["Vade hatırlatma (Plus)", "Vadesi geçen faturalar panelde görünür; Hatırlatma Gönder ile e-posta (ve tanımlıysa WhatsApp) gider.", "/"],
  ] },
  { title: "Raporlar ve Yapay Zekâ", items: [
    ["Excel dışa aktarma (Plus)", "Raporlar → Excel: cariler, hareketler, stok ve sevk bekleyenler tek dosyada.", "/raporlar"],
    ["Yapay zekâ özeti (Pro)", "Panelde Yapay Zekâ Özeti ile alacak/borç/stok durumunun Türkçe yorumunu alın. Ayarlar'dan ChatGPT veya Gemini seçebilirsiniz.", "/"],
  ] },
  { title: "Hesap ve Güvenlik", items: [
    ["Planım", "Ayarlar → Planım: kalan süre, plan satın alma (kartla 30 gün) veya havale için WhatsApp.", "/plan"],
    ["Aktif oturumlar", "Ayarlar → Aktif Oturumlar: giriş yapılmış cihazları görün, tanımadıklarınızı kapatın. Yeni cihazdan girişte e-posta uyarısı alırsınız.", "/ayarlar"],
    ["İşlem geçmişi", "Kim, ne zaman, hangi kaydı ekledi/değiştirdi/sildi — Ayarlar → İşlem Geçmişi.", "/islem-gecmisi"],
  ] },
];

function Item({ q, a, to }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b last:border-0">
      <button type="button" onClick={() => setOpen(!open)} className="flex w-full items-center justify-between py-3 text-left text-sm font-semibold hover:text-teal-800" data-testid={`guide-item-${q}`}>
        {q}<CaretDown className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="pb-3 text-sm text-slate-600">{a} {to && <Link to={to} className="font-semibold text-teal-700 hover:underline">Sayfaya git →</Link>}</div>}
    </div>
  );
}

export default function Guide() {
  return (
    <div data-testid="guide-page">
      <PageHeader eyebrow="Yardım" title="Nasıl yapılır?" />
      <p className="mb-6 flex items-center gap-2 text-sm text-slate-600"><BookOpen size={18} /> Adım adım rehber. Takıldığınız yerde WhatsApp: <a href="https://wa.me/905330707431" target="_blank" rel="noreferrer" className="font-semibold text-teal-700">0533 070 74 31</a></p>
      <div className="grid gap-4 lg:grid-cols-2">
        {GUIDE.map((g) => (
          <section key={g.title} className="panel p-5" data-testid={`guide-section-${g.title}`}>
            <h2 className="font-display text-lg font-bold">{g.title}</h2>
            <div className="mt-2">{g.items.map(([q, a, to]) => <Item key={q} q={q} a={a} to={to} />)}</div>
          </section>
        ))}
      </div>
    </div>
  );
}
